import { calculoAcumulado } from '../../../models/calculoAcumulado.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';
import * as moment from 'moment'

@Component({
  selector: 'app-calculo-acumulado-cesiones',
  templateUrl: './calculo-acumulado-cesiones.component.html',
  styleUrls: ['./calculo-acumulado-cesiones.component.css'],
  providers: [FormService]
})
export class CalculoAcumuladoCesionesComponent {
  public rows = [];
  public actualRow;
  public calculoAcumulado: calculoAcumulado;
  public form;
  public num;
  public matcher = new FormService();
  public formNumber;
  public formulario;
  public proyectoAnte = "";
  public tituloContinuacion = "";


  public form211;
  public form212;
  public form213;
  public form214;

  public form231;
  public form232;
  public form233;
  public form234;
  public form235;

  public form251;
  public form252;
  public form253;
  public form254;
  public form255;

  public fecha;
  public maxDate;
  public tipo_alt;
  public tipo_rec;
  public alteracionSupresionAdicion = false;
  public alteracionResRemReh = false;

  constructor() {

   this.formulario = localStorage.getItem("form")


    if (this.formulario == "1-1.1") {
      this.num = '6.7';
    }

    if (this.formulario == "2-1.1") {
      this.form211 = true
    }
    if (this.formulario == "2-1.2") {
      this.form212 = true
    }
    if (this.formulario == "2-1.3") {
      this.form213 = true
    }
    if (this.formulario == "2-1.4") {
      this.form214 = true
    }
    if (this.formulario == "2-3.1") {
      this.form231 = true;
    }
    if (this.formulario == "2-3.2") {
      this.form232 = true;
    }
    if (this.formulario == "2-3.3") {
      this.form233 = true;
    }
    if (this.formulario == "2-3.4") {
      this.form234 = true;
    }
    if (this.formulario == "2-3.5") {
      this.form235 = true;
    }

    if (this.formulario == "2-5.1") {
      this.form251 = true;
    }
    if (this.formulario == "2-5.2") {
      this.form252 = true;
    }
    if (this.formulario == "2-5.3") {
      this.form253 = true;
    }
    if (this.formulario == "2-5.4") {
      this.form254 = true;
    }
    if (this.formulario == "2-5.5") {
      this.form255 = true;
    }



    this.maxDate = moment().toDate()

    this.form = new FormGroup({
      permisoN1: new FormControl('', [Validators.pattern(/^[0-9]\d*$/)]),
      permisoN2: new FormControl('', [Validators.pattern(/^[0-9]\d*$/)]),

      fechaN1: new FormControl(''),
      fechaN2: new FormControl(''),

      porcentajeN1: new FormControl(0, [Validators.pattern(/^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/)]),
      porcentajeN2: new FormControl(0, [Validators.pattern(/^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/)]),
      porcentajeN3: new FormControl(0, [Validators.pattern(/^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/)]),


    })

    if (!JSON.parse(localStorage.getItem("calculoAcumulado"))) {
      localStorage.setItem("calculoAcumulado", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("calculoAcumulado"));
      this.form.controls['permisoN1'].setValue(this.rows[0] ? this.rows[0].permisoN1 : '');
      this.form.controls['permisoN2'].setValue(this.rows[0] ? this.rows[0].permisoN2 : '');


      this.form.controls['fechaN1'].setValue(new Date(this.rows[0] ? this.rows[0].fechaN1 : ''));
      this.form.controls['fechaN2'].setValue(new Date(this.rows[0] ? this.rows[0].fechaN2 : ''));


      this.form.controls['porcentajeN1'].setValue(this.rows[0] ? this.rows[0].porcentajeN1 : 0);
      this.form.controls['porcentajeN2'].setValue(this.rows[0] ? this.rows[0].porcentajeN2 : 0);
      this.form.controls['porcentajeN3'].setValue(this.rows[0] ? this.rows[0].porcentajeN3 : 0);




    }
    this.calculoAcumulado = {

      permisoN1: "",
      permisoN2: "",


      fechaN1: "",
      fechaN2: "",


      porcentajeN1: 0,
      porcentajeN2: 0,
      porcentajeN3: 0,

    };

  }

  add_calculoAcumulado() {
    console.log(this.form.controls['porcentajeN1'])

    localStorage.setItem("calculoAcumulado", JSON.stringify([]));
    this.actualRow = localStorage.getItem("calculoAcumulado");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      permisoN1: this.form.value.permisoN1,
      permisoN2: this.form.value.permisoN2,


      fechaN1: this.form.value.fechaN1 ? moment(this.form.value.fechaN1).format('DD/MM/YYYY') : "",
      fechaN2: this.form.value.fechaN2 ? moment(this.form.value.fechaN2).format('DD/MM/YYYY') : "",


      porcentajeN1: (this.form.value.porcentajeN1),
      porcentajeN2: (this.form.value.porcentajeN2),
      porcentajeN3: (this.form.value.porcentajeN3)


    })
    localStorage.setItem("calculoAcumulado", JSON.stringify(this.rows));

  }

  delete_Caract_anteproyecto_obranueva(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("calculoAcumulado", JSON.stringify(this.rows));
      }
    }
  }

  onNgModelChangeAlt(event) {
    console.log('on ng model change', event)


    this.tipo_alt = event
    this.add_calculoAcumulado()
  }


}
